import wx from 'weixin-js-sdk'
/**
 * @author caienlei <caienlei@xiaomi.com>
 * @global platform  - 判断客户端
 * @func goProduct   - 跳转详情页
 * @func isLogin     - 判断登录态
 * @func doLogin     - 登录的方法
 */
/** @global */
let _uA = navigator.userAgent.toLowerCase()

/**
 * platform 商城平台判断
 * @property {boolean} platform.isApp            - 小米商城安卓客户端
 * @property {boolean} platform.isIOSApp         - 小米商城苹果客户端
 * @property {boolean} platform.isMiniprogram    - 小米商城微信小程序
 */

let platform = {}

platform.isApp = (function () {
  if (typeof WE !== 'undefined' && _uA.indexOf('xiaomi/miuibrowser/4.3/shop') !== -1 && _uA.indexOf('iphone') === -1) {
    return true
  }
  return false
})()

platform.isIOSApp = (function () {
  if (/xiaomi/i.test(_uA) && /iphone/i.test(_uA)) {
    return true
  }
  return false
})()

platform.isMiniprogram = false

function miniProgramReady() {
  platform.isMiniprogram = !!(window.__wxjs_environment === 'miniprogram')
}

if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
  document.addEventListener('WeixinJSBridgeReady', miniProgramReady, false)
} else {
  miniProgramReady()
}

/**
 * 跳转小米商城单品详情页
 * @param {string} pid - 产品id.
 */
function goProduct(pid) {
  let xiaomiProductPath = {
    'path': 'ShopPlugin://com.xiaomi.shop2.plugin.goodsdetail.GoodsDetailFragment?pluginId=101',
    'extra': {
      'commodityId': pid
    }
  }
  let xiaomiMiUrl = `//m.mi.com/commodity/detail/${pid}`
  let xiaomiMiniPath = `/pages/product/index?id=${pid}`
  if (platform.isApp) window.WE.trigger('show_plugin', JSON.stringify(xiaomiProductPath))
  if (platform.isIOSApp) window.WE.trigger('show_plugin', encodeURIComponent(JSON.stringify(xiaomiProductPath)))
  if (platform.isMiniprogram) {
    try {
      wx.miniProgram.navigateTo({
        url: xiaomiMiniPath
      })
    } catch (e) {
      console.error('检查是否已经引用 https://res.wx.qq.com/open/js/jweixin-1.6.0.js');
    }
  }
  if (!platform.isApp && !platform.isIOSApp && !platform.isMiniprogram) window.top.location.href = xiaomiMiUrl
}
/**
 * 返回小米商城登录状态
 * @returns {boolean}
 */
function isLogin() {
  if(document.cookie.indexOf('cUserId') !== -1) {
    return true
  }else{
    return false
  }
}
/**
 * 小米商城登录方法
 */
function doLogin() {
  if (platform.isApp) {
    window.WE.trigger('login', null)
  } else {
    window.top.location.href = `//i.huodong.mi.com/site/login?redirectUrl=${encodeURIComponent(location.href)}`
  }
}


/**
 * 小米商城登录回调
 * @callback _loginCallback
 */
function _loginCallback() {
  window.top.location.reload()
}
export{
  isLogin,
  doLogin,
  goProduct,
  _loginCallback
}